import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Nullable } from "../../../../../Types/Common";
import { ChangeEvent } from "react";
import { DateObject } from "react-multi-date-picker";

interface IInitialState {
  sidebarOn: boolean;
  isFilter: boolean;
  sizeUserMaster: number;
  pageUserMaster: number;
  userSearchMaster: Nullable<string>;
  userStatusMaster: Nullable<number>;
  selectFilter: string;
  dateFilters: {
    dojDate: Nullable<Array<DateObject>>;
    dobDate: Nullable<Array<DateObject>>;
    anniversaryDate: Nullable<Array<DateObject>>;
    exitDate: Nullable<Array<DateObject>>;
  };
  departmentMasterId: Nullable<number>;
  jobTypeMaster: Nullable<string>;
  centerMasterId: Nullable<number>;
  selectableFieldMaster: Array<string>;
}

const initialState: IInitialState = {
  sidebarOn: false,
  isFilter: false,
  sizeUserMaster: 10,
  pageUserMaster: 1,
  userSearchMaster: null,
  userStatusMaster: null,
  selectFilter: "Select",
  dateFilters: {
    dojDate: null,
    dobDate: null,
    anniversaryDate: null,
    exitDate: null,
  },
  departmentMasterId: null,
  jobTypeMaster: null,
  centerMasterId: null,
  selectableFieldMaster: [
    "employee_code",
    "employee_name",
    "official_email",
    "centre_name",
    "department_name",
    "designation",
    "doj",
    "dob",
    "pan_number",
    "aadhar_number",
    "phone_number",
    "marital_status",
    "father_name",
    "mother_name",
    "spouse_name",
    "bank_name",
    "account_number",
    "account_type",
    "ifsc_code",
    "status",
  ],
};

const hrEmployeeMasterReportFilter = createSlice({
  name: "hrEmployeeMasterReportFilter",
  initialState,
  reducers: {
    setSidebarOn: (state) => {
      state.sidebarOn = !state.sidebarOn;
    },
    setIsFilter: (state) => {
      state.isFilter = !state.isFilter;
    },
    setSelectFilter: (state, action: PayloadAction<string>) => {
      state.selectFilter = action.payload;
    },
    setSizeUserMaster: (state, action: PayloadAction<number>) => {
      state.sizeUserMaster = action.payload;
    },
    setPageUserMaster: (state, action: PayloadAction<number>) => {
      state.pageUserMaster = action.payload;
    },
    setUserSearchMaster: (state, action: PayloadAction<Nullable<string>>) => {
      state.userSearchMaster = action.payload;
    },
    setUserStatusMaster: (state, action: PayloadAction<number>) => {
      state.userStatusMaster = action.payload;
    },
    setDateFilters: (
      state,
      action: PayloadAction<{
        dojDate?: Nullable<Array<DateObject>>;
        dobDate?: Nullable<Array<DateObject>>;
        anniversaryDate?: Nullable<Array<DateObject>>;
        exitDate?: Nullable<Array<DateObject>>;
      }>
    ) => {
      const { dojDate, dobDate, anniversaryDate, exitDate } = action.payload;

      if (dojDate !== undefined) {
        state.dateFilters.dojDate = dojDate;
      }
      if (dobDate !== undefined) {
        state.dateFilters.dobDate = dobDate;
      }
      if (anniversaryDate !== undefined) {
        state.dateFilters.anniversaryDate = anniversaryDate;
      }
      if (exitDate !== undefined) {
        state.dateFilters.exitDate = exitDate;
      }
    },
    setDepartmentMasterId: (state, action: PayloadAction<Nullable<number>>) => {
      state.departmentMasterId = action.payload;
    },
    setJobTypeMaster: (state, action: PayloadAction<Nullable<string>>) => {
      state.jobTypeMaster = action.payload;
    },
    setCenterMasterId: (state, action: PayloadAction<Nullable<number>>) => {
      state.centerMasterId = action.payload;
    },
    setSelectableFieldMaster: (
      state,
      action: PayloadAction<ChangeEvent<HTMLInputElement>>
    ) => {
      const { value, checked } = action.payload.target;
      if (checked) {
        state.selectableFieldMaster = [...state.selectableFieldMaster, value];
      } else {
        state.selectableFieldMaster = state.selectableFieldMaster.filter(
          (v) => v !== value
        );
      }
    },
    setSelectableFieldMasterReset: (state) => {
      state.selectableFieldMaster = initialState.selectableFieldMaster;
    },
    // NEW: replace the entire selection in one go (for Select All / Uncheck All / radio)
    setSelectableFieldMasterReplace: (
      state,
      action: PayloadAction<string[]>
    ) => {
      state.selectableFieldMaster = action.payload;
    },
  },
});

export const {
  setSidebarOn,
  setIsFilter,
  setPageUserMaster,
  setSizeUserMaster,
  setUserSearchMaster,
  setUserStatusMaster,
  setSelectFilter,
  setDateFilters,
  setDepartmentMasterId,
  setJobTypeMaster,
  setCenterMasterId,
  setSelectableFieldMaster,
  setSelectableFieldMasterReset,
  setSelectableFieldMasterReplace,
} = hrEmployeeMasterReportFilter.actions;

export default hrEmployeeMasterReportFilter.reducer;
